let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e2gl6")).then(() => parcelRequire('bCdvh'));